export const FETCHING = "TEAMLEADERSHIP/FETCHING"
export const SUCCESS = "TEAMLEADERSHIP/SUCESS"
export const ERROR = "TEAMLEADERSHIP/ERROR"